import Cry from '@/assets/animations/Cry.json'
import {Animation} from '@/components/ui/animation/Animation'
import {Button} from '@/components/ui/button/Button'
import {Modal} from '@/components/ui/modal/Modal'
import {FC, useState} from 'react'
import {
    StyledAnimationContainer,
    StyledButtonsContainer,
    StyledDowngradePlanModalContainer,
    StyledInformContainer,
    StyledInformDescription,
    StyledInformTitle
} from './style'
import {useTranslation} from 'react-i18next'

type DowngradePlanModalProps = {
    onClose: () => void
    action: () => void
}
const DowngradePlanModal: FC<DowngradePlanModalProps> = ({onClose, action}) => {
    const {t} = useTranslation()
    const [status, setStatus] = useState<'pending' | 'success'>('pending')
    const isPending = status === 'pending'
    const onCloseHandler = () => {
        if (isPending) onClose()
        else action()
    }
    return (
        <Modal fullScreen onClose={onClose}>
            <StyledDowngradePlanModalContainer>
                <StyledAnimationContainer>
                    <Animation animationData={Cry} />
                </StyledAnimationContainer>
                <StyledInformContainer>
                    <StyledInformTitle>
                        {t(isPending ? 'downgrade_plan_modal:title_pending' : 'downgrade_plan_modal:title_success')}
                    </StyledInformTitle>
                    <StyledInformDescription>
                        {t(
                            isPending
                                ? 'downgrade_plan_modal:description_pending'
                                : 'downgrade_plan_modal:description_success'
                        )}
                    </StyledInformDescription>
                </StyledInformContainer>
                <StyledButtonsContainer>
                    {isPending && (
                        <Button
                            variant="outlined"
                            onClick={() => {
                                // action()
                                setStatus('success')
                            }}
                        >
                            {t('downgrade_plan_modal:CTA')}
                        </Button>
                    )}

                    <Button onClick={onCloseHandler}>{t(isPending ? 'common:cancel' : 'common:continue')}</Button>
                </StyledButtonsContainer>
            </StyledDowngradePlanModalContainer>
        </Modal>
    )
}
export default DowngradePlanModal
